import { Card, Flex } from "antd";

import variables from "../../../../../_variables.scss";
import {
  DeficientProjects,
  ProjectsByStage,
  ProjectsTimeTrackingSummary,
} from "projects/components";
import { IProjectsInfo } from "projects/models";

export const OwnerDashboardProjectCard = ({
  loading,
  projectsInfo,
}: {
  loading?: boolean;
  projectsInfo?: IProjectsInfo;
}) => {
  return (
    <Card
      data-testid='ownerDashboardProjectCard'
      className='owner-dashboard-project-card-container'
      loading={loading}
      bordered={false}
    >
      <Flex vertical gap={variables.gap}>
        <h1>Projects</h1>
        <Flex gap={variables.gap}>
          <ProjectsByStage projectsByStage={projectsInfo?.projectsByStage ?? []} height={variables.defaultComponentHeight} />
          <ProjectsTimeTrackingSummary projectsTimeTrackingSummary={projectsInfo?.projectsTimeTrackingSummary ?? []} />
        </Flex>
        <DeficientProjects deficientProjects={projectsInfo?.deficientProjects ?? []} />
      </Flex>
    </Card>
  );
};
